import { Stack } from '../../../../../design-system/stack/stack';
import { cn } from '../../../../../utils/cn';

type PdfLoadingSectionProps = {
  /**
   * Controls the positioning of the loading spinner within the PDF viewer
   *
   * When true, the spinner is positioned for the Document component (initial PDF load)
   * When false, the spinner is positioned for the Page component (page transitions)
   *
   * This distinction is necessary because the Document and Page components
   * have different layout contexts in the PDF viewer library
   *
   * @default false
   */
  isPdfDocumentLoading?: boolean;
};

export const PdfLoadingSection = ({ isPdfDocumentLoading = false }: PdfLoadingSectionProps) => {
  return (
    <Stack
      align="center"
      justify="center"
      className={cn('absolute h-full w-full rounded-lg', {
        'top-0': !isPdfDocumentLoading,
        'right-0': isPdfDocumentLoading,
      })}
    >
      <div
        data-testid="pdf-loading-spinner"
        className="h-12 w-12 animate-spin rounded-full border-b-4 border-t-4 border-seapoint-yellow"
      />
    </Stack>
  );
};
